export function getCommercialPricing(priceData, wasteBinCom, recycleBinCom, organicBinCom, changeRecycleBinCom) {
    const commercialPriceDetails = {
      totalInitialFees: 0,
      totalAnnualFees: 0,
      items: []
    };

    const wasteBinPricing = priceData[4];
    const recycleBinPricing = priceData[5];
    const organicBinPricing = priceData[6];

    const wastePrice = wasteBinPricing.initalFee * wasteBinCom;
    const recyclePrice = recycleBinPricing.initalFee * recycleBinCom;
    const organicPrice = organicBinPricing.initalFee * organicBinCom;
    const changeSizePrice = recycleBinPricing.initalFee * changeRecycleBinCom;

    const wasteAnnualPrice = wasteBinPricing.annualFee * wasteBinCom;
    const recycleAnnualPrice = recycleBinPricing.annualFee * recycleBinCom;
    const organicAnnualPrice = organicBinPricing.annualFee * organicBinCom;

    if (wasteBinCom > 0) {
      commercialPriceDetails.items.push({
            description: 'General Waste(Red) Bin',
            quantity: wasteBinCom,
            upfront: wastePrice,
            annual: wasteAnnualPrice
        });
    }

    if (recycleBinCom > 0) {
      commercialPriceDetails.items.push({
            description: 'Recycling(Yellow) Bin',
            quantity: recycleBinCom,
            upfront: recyclePrice,
            annual: recycleAnnualPrice
        });
    }

    if (organicBinCom > 0) {
      commercialPriceDetails.items.push({
            description: 'Organic(Green) Bin',
            quantity: organicBinCom,
            upfront: organicPrice,
            annual: organicAnnualPrice
        });
    }

    if (changeRecycleBinCom > 0) {
      commercialPriceDetails.items.push({
            description: 'Resize Recycle(Yellow) Bin',
            quantity: changeRecycleBinCom,
            upfront: changeSizePrice,
            annual: 0
        });
    }

    commercialPriceDetails.totalInitialFees = wastePrice + recyclePrice + organicPrice + changeSizePrice;
    commercialPriceDetails.totalAnnualFees = wasteAnnualPrice + recycleAnnualPrice + organicAnnualPrice;

    return commercialPriceDetails;
}